// Version : 0.0.1
// Author : SATHISH
// LastEdit : KARTHEESWARAN
// MODFIED DATE:30-09-2025
//Last ADD : REMOVED EXCEL TYPES
const DayBookType = {
	/*****************  GET BANK  TRANSACTION LIST START  *******************/
	GET_DAYBOOK_LIST_START: 'get_daybook_report_list_start',
	GET_DAYBOOK_LIST_SUCCESS: 'get_daybook_report_list_success',
	GET_DAYBOOK_LIST_FAILURE: 'get_daybook_report_list_failure',
	GET_DAYBOOK_LIST_RESPONSE_RESET: 'get_daybook_report_list_response_reset',
	GET_DAYBOOK_LIST_RESPONSE_CHANGED: 'get_daybook_report_list_response_changed',
	/*****************  GET BANK  TRANSACTION LIST END  *******************/
};
export default DayBookType;
